module.exports = __webpack_public_path__ + "img/icon-arrow-right-inactive.21914cf0.svg";